module.exports = __webpack_public_path__ + "static/media/bank_icon.aa0640ea.png";